import { SelectedOptions } from '@shopify/hydrogen-react/ProductProvider';
import { ProductOption, SelectedOption } from '@shopify/hydrogen-react/storefront-api-types';
import classNames from 'classnames';
import React from 'react';
import { optionCombinationExists, handleOptionSelect } from '../functions';

interface Props {
  onSelectedOptions: (options: SelectedOptions) => void;
  selectedOptions: SelectedOptions;
  availableOptions: SelectedOption[][];
  outOfStockOptions?: SelectedOption[][];
  optionGroup: ProductOption;
}

const OptionText: React.FC<Props> = ({
  onSelectedOptions,
  selectedOptions,
  optionGroup,
  availableOptions,
  outOfStockOptions = [],
}) => {
  return (
    <div className="product-options-group color">
      {optionGroup.optionValues.map((optionValue, key) => {
        const selectedOption =
          optionGroup?.name && selectedOptions && selectedOptions[optionGroup.name];

        if (!optionGroup?.name) {
          return null;
        }

        const isAvailable = optionCombinationExists(
          availableOptions,
          selectedOptions,
          optionGroup.name,
          optionValue.name
        );

        const isOutOfStock = optionCombinationExists(
          outOfStockOptions,
          selectedOptions,
          optionGroup.name,
          optionValue.name
        );

        return (
          <div
            className={classNames({
              'product-options-group-item': true,
              active: selectedOption === optionValue.name,
              disabled: !isAvailable,
              'out-of-stock': isAvailable && isOutOfStock,
            })}
            key={key}
            onClick={() => {
              isAvailable &&
                onSelectedOptions(
                  handleOptionSelect(selectedOptions, optionGroup.name, optionValue.name)
                );
            }}
          >
            {optionValue.name}
          </div>
        );
      })}
    </div>
  );
};

export default OptionText;
